'use strict';

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/locale-provider/style/css.js
// module id = 1116
// module chunks = 0